import { render, staticRenderFns } from "./hotelList.vue?vue&type=template&id=cee28f22&scoped=true"
import script from "./hotelList.vue?vue&type=script&lang=js"
export * from "./hotelList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cee28f22",
  null
  
)

export default component.exports